<template>
  <div>
    <div class="relative" id="customize-roadmap-container">
      <transition name="fadeIn">
        <div
          class="drawer-backdrop"
          v-if="labelsOpen"
          @click.self="labelsOpen = false"
        ></div>
      </transition>

      <transition name="slideFromRight">
        <div class="drawer" v-if="labelsOpen">
          <!-- Header -->
          <div class="drawer__header">
            <div class="drawer__header-content">
              <h3 class="drawer__title">{{ $t('Edit Roadmap') }}</h3>
              <p class="drawer__subtitle">{{ $t("Choose which statuses are shown and their order") }}</p>
            </div>
            <button
              type="button"
              @click.prevent="labelsOpen = false"
              class="drawer__close"
              :title="$t('Close')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <!-- Body -->
          <div class="drawer__body">
            <p class="text-sm text-neutral-600 mb-4">
              {{ $t('Drag to reorder columns. Toggle visibility to show or hide statuses on your roadmap.') }}
            </p>

            <div class="drawer__list">
              <draggable
                @change="sortingStatus"
                :list="filteredStatus"
                :animation="200"
                ghost-class="moving-card"
                filter=".action-button"
                class="w-full"
                @start="drag = true"
                @end="drag = false"
                :options="{ handle: '.handle' }"
              >
                <transition-group>
                  <RoadmapStatusLabel
                    v-for="label in filteredStatus"
                    :original-label="label"
                    :key="label.id"
                    :project-id="projectId"
                    @updatedStatusRoadmap="updatedStatusRoadmap($event)"
                  />
                </transition-group>
              </draggable>
            </div>
          </div>

          <!-- Success Toast -->
          <transition name="fadeIn">
            <div v-if="successMessage" class="drawer__toast">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              {{ $t("Changes saved") }}
            </div>
          </transition>
        </div>
      </transition>

      <!-- Open Drawer Button -->
      <small>
        <button
          class="w-full text-sm bg-white border border-neutral-300 rounded-lg bg-gradient-to-b from-white to-neutral-100 shadow-sm px-3 py-1 text-dblue-500 flex items-center focus:to-white focus:border-neutral-400 focus:outline-none hover:border-neutral-400 transition-colors"
          @click.prevent="getStatuses"
        >
          <svg
            class="w-4 h-4 mr-2"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
          </svg>
          <span>{{ $t('Edit Roadmap') }}</span>
        </button>
      </small>
    </div>
  </div>
</template>

<script>
import RoadmapStatusLabel from "./roadmap_status_label";
import EventBus from "event_bus";
import draggable from "vuedraggable";

export default {
  props: ["post-status", "project-id", "button_status", "status-ids", "status-name"],

  data: function() {
    return {
      allStatuses: this.postStatus,
      labelsOpen: false,
      filteredStatus: [],
      statusId: this.statusIds,
      successMessage: false
    };
  },

  mounted: function() {
    this.keydownHandler = e => {
      if (e.key === "Escape") {
        this.labelsOpen = false;
      }
    };
    window.addEventListener("keydown", this.keydownHandler);
    this.filteredStatus = this.filterByNotSet();

    this.statusLabelHandler = status => {
      this.allStatuses = status;
    };
    EventBus.$on("status_label", this.statusLabelHandler);

    this.statusIdsHandler = ids => {
      this.statusId = ids;
    };
    EventBus.$on("status_ids", this.statusIdsHandler);
  },

  components: {
    RoadmapStatusLabel,
    draggable
  },

  methods: {
    filterByNotSet() {
      const result = this.allStatuses.filter(
        status => status.name !== this.statusName.not_set
      );
      const filterStatus = this.statusId.map(id => {
        return result.find(status => status.id === id);
      });
      return filterStatus;
    },

    updatedStatusRoadmap(status) {
      this.showSuccess();
      EventBus.$emit("status_label", status);
    },

    showSuccess() {
      this.successMessage = true;
      setTimeout(() => {
        this.successMessage = false;
      }, 2000);
    },

    sortingStatus() {
      const statusIds = this.filteredStatus.map(status => {
        return status.id;
      });
      let params = new FormData();

      params.append("status[project_id]", this.projectId);
      params.append("status[status_ids]", statusIds);

      Rails.ajax({
        url: "/statuses/filter_status",
        type: "POST",
        data: params,
        dataType: "json",
        beforeSend: function() {
          return true;
        },
        success: data => {
          this.statusId = data.status_id;
          this.showSuccess();
          EventBus.$emit("status_ids", data.status_id);
        },
        error: (data, status) => {
          console.log(data);
        }
      });
    },

    getStatuses() {
      Rails.ajax({
        url: "/statuses?project_id=" + this.projectId,
        type: "GET",
        dataType: "json",
        beforeSend: function() {
          return true;
        },
        success: data => {
          this.allStatuses = data.status_label;
          this.statusId = data.status_ids;
        },
        error: (data, status) => {}
      });
      this.labelsOpen = !this.labelsOpen;
    }
  },

  watch: {
    allStatuses: function() {
      this.filteredStatus = this.filterByNotSet();
    }
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keydownHandler);
    EventBus.$off("status_label", this.statusLabelHandler);
    EventBus.$off("status_ids", this.statusIdsHandler);
  }
};
</script>

<style scoped>
/* Drawer styles are global */
</style>
